/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************************!*\
  !*** ./src/assets/js/market-sidebar.js ***!
  \*****************************************/
function docReady(fn) {
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(fn, 3000);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

function openDrawer() {
  document.querySelector("#sidebar-drawer").classList.add("open");
  document.getElementById("html").style.overflow = 'hidden';
}

function closeDrawer() {
  document.querySelector("#sidebar-drawer").classList.remove("open");
  document.getElementById("html").style.overflow = 'auto';
}

docReady(function () {
  document.querySelectorAll(".open-drawer").forEach(function (btn) {
    return btn.addEventListener("click", openDrawer);
  });
  document.querySelectorAll(".close-drawer").forEach(function (btn) {
    return btn.addEventListener("click", closeDrawer);
  });
});
/******/ })()
;